module.exports = __webpack_public_path__ + "static/media/tunghøyrd.6b1141a8.m4a";